<template>
    <div class="template-select-widget">
        <template v-for="(option, index) in options">
            <div class="option-widget-item" :key="index" :class="{ active: option.value == value }"
                @click="selectItem(option)">
                <span class="icon" v-if="option.icon && option.icon.left">
                    <img v-if="option.value == value" :src="option.icon.left.active">
                    <img v-else :src="option.icon.left.inactive">
                </span>
                <span v-if="option.label">{{ option.label }}</span>
            </div>

        </template>

    </div>
</template>
<script>
import { eventBus } from "@/main";
export default {
    name: "editor-property",
    components: {

    },
    props: {
        value: {
            type: [String, Number, Boolean],
            default: "",
        },
        options: {
            type: Array,
            default: () => [],
            required: true,
        },
    },
    data() {
        return {
        };
    },

    mounted() {
        let vm = this;

    },
    computed: {
        selecteValue() {
            let selected = this.options.find((item) => item.value == this.value);
            return selected ? selected.label : '';
        },
    },
    methods: {
        selectItem(item) {
            this.$emit("input", item.value);
        },
    },
};
</script>
  
<style lang="scss" scoped>
$assets: "~@/assets";

.template-select-widget {
    display: flex;
    align-items: center;
    position: relative;
    width: 100%;
    height: 30px;
    border-radius: 5px;
    border: 1px solid #BFBFBF;
    padding: 1px;

    .option-widget-item {
        padding: 0 10px;
        height: 100%;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        margin-right: 3px;
        position: relative;

        .icon {
            margin-right: 5px;
        }

        &:hover {
            border-radius: 5px;
            background-color: #ededed;
        }

        &.active {
            background-color: #0884AF;
            border-radius: 5px;
            color: #fff;
        }
    }
}
</style>